import axiosInstance from "../../axios";
import AXIOS_ROUTES from "../../axios/routes";

export const searchTrainersApi = async (data: any) => {
    return await axiosInstance.post(AXIOS_ROUTES.trainers.search, data);
}

export const createTrainerApi = async (data: any) => {
    return await axiosInstance.post(AXIOS_ROUTES.trainers.createTrainer, data);
}